export class AWRContextResponse {
    accountNumber: string;
    timePeriod: string;
    goToTab: string;
    awrAccount: String;
}
